import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

import { useSidebarLayout } from 'providers/root/SidebarLayoutProvider';

import useStyles from './styles';

function ExternalLinkItem({ disabled, label, startIcon, endIcon, complementIcon, onClick, openMenu, link, ...others }) {
  const classes = useStyles();
  const { setOpenDrawer } = useSidebarLayout();

  function handleClick(event) {
    setOpenDrawer(false);

    if (onClick) {
      onClick(event);
    }
  }

  return (
    <li className={classes.item} data-testid="navExternalLinkItem">
      <Box
        className={clsx(classes.navLink, {
          [classes.link]: true,
          [classes.navLinkExtenal]: openMenu,
          [classes.navLinkStartIcon]: startIcon,
          [classes.disabled]: disabled,
          [classes.collapseMenu]: !openMenu,
        })}
        component="a"
        disabled={disabled}
        href={link}
        justifyContent="flex-start"
        onClick={handleClick}
        rel="noopener noreferrer"
        style={{ cursor: 'pointer' }}
        target="_blank"
        {...others}
      >
        {startIcon && <span>{startIcon}</span>}
        {openMenu ? (
          <>
            <span
              className={clsx(classes.navLinkLabel, { [classes.navLinkLabelComplementIcon]: complementIcon })}
              data-testid="navLinkLabel"
            >
              {label} {complementIcon && complementIcon}
            </span>

            {endIcon && endIcon}
          </>
        ) : null}
      </Box>
    </li>
  );
}

ExternalLinkItem.propTypes = {
  disabled: PropTypes.bool,
  endIcon: PropTypes.node,
  label: PropTypes.string,
  startIcon: PropTypes.node,
  onClick: PropTypes.func,
  complementIcon: PropTypes.node,
  openMenu: PropTypes.bool,
};

export default ExternalLinkItem;
